export default __webpack_public_path__ + "static/media/FirstPick_159x150.4650c913.png";